import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KnBrUpdateTemplateDialogComponent } from 'src/app/sales-libs/kn-br-nac/components/kn-br-update-template-dialog/kn-br-update-template-dialog.component';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { environment } from 'src/environments/environment';
import { SloanNacTemplateModel } from '../../../models/sloan/sloan-nac-template-model';
import { SimpleFileUploadComponent, FilesAcceptDirective } from '@iplab/ngx-file-upload';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'knbr-sloan-update-template-dialog',
    templateUrl: './sloan-update-template-dialog.component.html',
    styleUrls: ['./sloan-update-template-dialog.component.scss'],
    imports: [SimpleFileUploadComponent, FilesAcceptDirective, TranslatePipe]
})
export class SloanUpdateTemplateDialogComponent extends KnBrUpdateTemplateDialogComponent implements OnInit {
  constructor(protected activeModal: NgbActiveModal, protected sloanCommonService: KnBrCommonService) {
    super(activeModal, sloanCommonService);
  }
  baseURL = environment.BASEURL;

  @Input() templateData: SloanNacTemplateModel;

  ngOnInit(): void {
    super.ngOnInit();
  }

  update() {
    if (this.fileUploadControl.value.length > 0) {
      const formData: FormData = new FormData();
      formData.append('attachment', this.fileUploadControl.value[0]);
      this.sloanCommonService.updateNacTemplate(this.templateData.templateName, formData);
      this.activeModal.close();
    }
  }
}
